var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnpublishWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Unpublish",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 9.5) scale(1, -1) translate(-9, -9.5)translate(2, 2.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#b8b8ce",
    x: 0,
    y: 0,
    width: 14,
    height: 1.4,
    rx: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-2",
    transform: "translate(0.4245, 2.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 13,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17247463,5.40303361 L10.9785419,5.40303361 L8.69648826,2.82752537 M10.9785419,5.40303361 L8.69648826,7.97854186",
    id: "Vector",
    stroke: "#b8b8ce",
    strokeWidth: 1.5,
    opacity: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(6.5755, 5.403) rotate(-90) translate(-6.5755, -5.403)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpublishWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Unpublish-White.f58172b5c78339bbc45afebcb5f89316.svg";